import _ from 'lodash';
import actionTypes from '../actions/action_types';

const initialState = {
  invite: null,
};

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.INVITE_RESOLVED: {
      const { invite } = action.payload;

      result = _.assign({}, state, {
        invite,
      });
      break;
    }

    default: {
      result = _.assign({}, state);
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/guest.js